import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { SpecialOrderUndelivered } from "../../types/special-order.type";
import { formatDate } from "../../utils/date";
import { undeliveredReasonLabel } from "./data";

const stamp = ({ at, by_name }: SpecialOrderUndelivered) => {
  const when = formatDate(at, "DD/MM/YYYY HH:mm");
  return by_name ? `${when} · ${by_name}` : when;
};

/**
 * The van said it did not deliver. The order is still open — the back office decides
 * whether to re-date it or cancel — so this sits where "waiting for the van" would be.
 */
export default function UndeliveredAlert({
  undelivered,
}: Readonly<{ undelivered: SpecialOrderUndelivered }>) {
  return (
    <Alert severity="warning">
      <Typography variant="body2" fontWeight={600}>
        สายส่งแจ้งว่ายังไม่ได้ส่ง: {undeliveredReasonLabel(undelivered.reason)}
      </Typography>
      {undelivered.note && <Typography variant="body2">{undelivered.note}</Typography>}
      <Typography variant="caption" color="text.secondary">
        {stamp(undelivered)}
      </Typography>
    </Alert>
  );
}

/** The list row's hint, next to the "ยืนยันสั่ง" chip. */
export function UndeliveredChip({
  undelivered,
}: Readonly<{ undelivered: SpecialOrderUndelivered }>) {
  const reason = undeliveredReasonLabel(undelivered.reason);
  return (
    <Tooltip title={undelivered.note ? `${reason} · ${undelivered.note}` : reason}>
      <Chip size="small" color="warning" variant="outlined" label="แจ้งไม่ได้ส่ง" />
    </Tooltip>
  );
}
